
    <girko-header
      [service]="service$|async"
      (goToProfile)="goToProfile($event)"
      (hamburgerClick)="hamburgerClick.emit()"
    ></girko-header>
  